export default [
  {
    "id": "mat-enem-0940",
    "numero": 2440,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Em um mês, uma loja de eletrônicos começa a \nobter lucro já na primeira semana. O gráfico \nrepresenta o lucro (L) dessa loja desde o início \ndo mês até o dia 20. Mas esse comportamento \nse estende até o último dia, o dia 30. \n \n \n \nA representação algébrica do lucro (L) em fun-\nção do tempo (t) é: \n \nA) L(t) = 20t + 3000 \nB) L(t) = 20t + 4000 \nC) L(t) = 200t \nD) L(t) = 200t - 1000 \nE) L(t) = 200t + 3000",
    "alternativas": {
      "C": "L(t) = 200t",
      "D": "L(t) = 200t - 1000",
      "E": "L(t) = 200t + 3000",
      "B": "L(t) = 20t + 4000"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 940,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0942",
    "numero": 2442,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Um dos principais indicadores de inflação é o Índice Nacional de Preços ao Consumidor Amplo (IPCA). \nO gráfico apresenta os valores do IPCA nos anos de 1994 a 2011. \n \n \n \n(Disponível em: www.ibge.gov.br. Acesso em: 2 ago. 2012 - adaptado) \n \nO valor mais próximo da mediana de todos os valores da inflação indicados no gráfico é: \n \nA) 5,97. \nB) 6,24. \nC) 6,50. \nD) 8,07. \nE) 10,10.",
    "alternativas": {
      "A": "5,97.",
      "B": "6,24.",
      "D": "8,07.",
      "E": "10,10."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 942,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0943",
    "numero": 2443,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Uma equipe de ambientalistas apresentou um mapa de uma reserva ambiental em que faltava a especi-\nficação da escala utilizada para a sua confecção.  \n \nO problema foi resolvido, pois um dos integrantes da equipe lembrava-se de que a distância real de 72 \nkm, percorrida na reserva, equivale a 3,6 cm no mapa. \n \nQual foi a escala utilizada na confecção do mapa? \n \nA) 1 : 20 \nB) 1 : 2000 \nC) 1 : 20000 \nD) 1 : 200000 \nE) 1 : 2000000",
    "alternativas": {
      "E": "1 : 2000000",
      "A": "1 : 20",
      "B": "1 : 2000",
      "C": "1 : 20000"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 943,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0944",
    "numero": 2444,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "Desde 1999 houve uma significativa mudança \nnas placas dos carros particulares em todo o \nBrasil. As placas, que antes eram formadas \napenas por seis caracteres alfanuméricos, fo-\nram acrescidas de uma letra, passando a ser \nformadas por sete caracteres, sendo que os três \nprimeiros caracteres devem ser letras (dentre as \n26 letras do alfabeto) e os quatro últimos devem \nser algarismos (de 0 a 9). Essa mudança possi-\nbilitou a criação de um cadastro nacional unifi-\ncado de todos os veículos licenciados e ainda \naumentou significamente a quantidade de com-\nbinações possíveis de placas. Não são utiliza-\ndas placas em que todos os algarismos sejam \niguais a zero. \n \n(Disponível em: http://g1.globo.com.  \nAcesso em: 14 jan. 2012 - adaptado) \n \nNessas condições, a quantidade de placas que \npodem ser utilizadas é igual a: \n \nA) 263 + 94 \nB) 263 x 94 \nC) 263 (104 - 1) \nD) (263 + 104) - 1 \nE) (263 x 104) - 1",
    "alternativas": {
      "B": "263 x 94",
      "C": "263 (104 - 1)",
      "D": "(263 + 104) - 1",
      "A": "263 + 94"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 944,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0945",
    "numero": 2445,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2017.2",
    "enunciado": "A figura traz o esboço da planta baixa de uma \nresidência. Algumas medidas internas dos cô-\nmodos estão indicadas. A espessura de cada \nparede externa da casa é 0,20 m e das paredes \ninternas, 0,10 m. \n \n \nSabe-se que, na localidade onde se encontra \nesse imóvel, o Imposto Predial Territorial Urba-\nno (IPTU) é calculado conforme a área constru-\nída da residência. Nesse cálculo, são cobrados \nR$4,00 por cada metro quadrado de área cons-\ntruída. \n \nO valor do IPTU desse imóvel, em real, é: \n \nA) 250,00. \nB) 250,80. \nC) 258,64. \nD) 276,48. \nE) 286,00.",
    "alternativas": {
      "C": "258,64.",
      "D": "276,48.",
      "E": "286,00.",
      "B": "250,80."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2017.2",
    "numeroOriginal": 945,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0946",
    "numero": 2446,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A Transferência Eletrônica Disponível (TED) é \numa transação financeira de valores entre dife-\nrentes bancos. Um economista decide analisar \nos valores enviados por meio de TEDs entre \ncinco bancos (1, 2, 3, 4 e 5) durante um mês. \nPara isso, ele dispõe esses valores em uma \nmatriz A = [aij], em que 1 ≤ i ≤ 5 e 1 ≤ j ≤ 5, e o \nelemento aij corresponde ao total proveniente \ndas operações feitas via TED, em milhão de \nreal, transferidos do banco i para o banco j du-\nrante o mês. Observe que os elementos aij = 0, \numa vez que TED é uma transferência entre \nbancos distintos. Esta é a matriz obtida para \nessa análise: \n \n \n \nCom base nessas informações, o banco que \ntransferiu a maior quantia via TED é o banco: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "C": "3.",
      "D": "4.",
      "E": "5.",
      "A": "1."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 946,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0947",
    "numero": 2447,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um contrato de empréstimo prevê que quando \numa parcela é paga de forma antecipada, con-\nceder-se-á uma redução de juros de acordo \ncom o período de antecipação. Nesse caso, \npaga-se o valor presente, que é o valor, naquele \nmomento, de uma quantia que deveria ser paga \nem uma data futura. Um valor presente P sub-\nmetido a juros compostos com taxa i, por um \nperíodo de tempo n, produz um valor futuro V \ndeterminado pela fórmula: \n \nV = P ∙ (1 + i)n \nEm um contrato de empréstimo com sessenta \nparcelas fixas mensais, de R$820,00, a uma \ntaxa de juros de 1,32% ao mês, junto com a \ntrigésima parcela será paga antecipadamente \numa outra parcela, desde que o desconto seja \nsuperior a 25% do valor da parcela. \n \nUtilize 0,2877 como aproximação para In (\n4\n3) e \n0,0131 como aproximação para In (1,0132). \n \nA primeira das parcelas que poderá ser anteci-\npada junto com a 30ª é a: \n \nA) 56ª \nB) 55ª \nC) 52ª \nD) 51ª \nE) 45ª",
    "alternativas": {
      "A": "56ª",
      "B": "55ª",
      "C": "52ª",
      "E": "45ª"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 947,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0948",
    "numero": 2448,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um jogo pedagógico utiliza-se de uma interface \nalgébrico-geométrica do seguinte modo: os alu-\nnos devem eliminar os pontos do plano cartesi-\nano dando “tiros”, seguindo trajetórias que de-\nvem passar pelos pontos escolhidos. Para dar \nos tiros, o aluno deve escrever em uma janela \ndo programa a equação cartesiana de uma reta \nou de uma circunferência que passa pelos pon-\ntos e pela origem do sistema de coordenadas. \nSe o tiro for dado por meio da equação da cir-\ncunferência, cada ponto diferente da origem que \nfor atingido vale 2 pontos. Se o tiro for dado por \nmeio da equação de uma reta, cada ponto dife-\nrente da origem que for atingido vale 1 ponto. \nEm uma situação de jogo, ainda restam os se-\nguintes pontos para serem eliminados: A(0 ; 4), \n6(4 ; 4), C(4 ; 0), D(2 ; 2) e E(0; 2). \n \n \n \nPassando pelo ponto A, qual equação fornece-\nria a maior pontuação? \n \nA) x = 0 \nB) y = 0 \nC) x² + y² =16 \nD) x² + (y - 2)² = 4 \nE) (x - 2)² + (y - 2)² = 8",
    "alternativas": {
      "A": "x = 0",
      "B": "y = 0",
      "C": "x² + y² =16",
      "E": "(x - 2)² + (y - 2)² = 8"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 948,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0950",
    "numero": 2450,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um artesão possui potes cilíndricos de tinta \ncujas medidas externas são 4 cm de diâmetro e \n6 cm de altura. Ele pretende adquirir caixas \norganizadoras para armazenar seus potes de \ntinta, empilhados verticalmente com tampas \nvoltadas para cima, de forma que as caixas \npossam ser fechadas. \nNo mercado, existem cinco opções de caixas \norganizadoras, com tampa, em formato de para-\nlelepípedo reto retângulo, vendidas pelo mesmo \npreço, possuindo as seguintes dimensões inter-\nnas: \n \n \n \nQual desses modelos o artesão deve adquirir \npara conseguir armazenar o maior número de \npotes por caixa? \n \nA) I \nB) II \nC) III \nD) IV \nE) V",
    "alternativas": {
      "E": "V",
      "B": "II",
      "C": "III",
      "D": "IV"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 950,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0951",
    "numero": 2451,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A prefeitura de um pequeno município do interi-\nor decide colocar postes para iluminação ao \nlongo de uma estrada retilínea, que inicia em \numa praça central e termina numa fazenda na \nzona rural. Como a praça já possui iluminação, \no primeiro poste será colocado a 80 metros da \npraça, o segundo, a 100 metros, o terceiro, a \n120 metros, e assim sucessivamente, manten-\ndo-se sempre uma distância de vinte metros \nentre os postes, até que o último poste seja \ncolocado a uma distância de 1380 metros da \npraça. \n \nSe a prefeitura pode pagar, no máximo, \nR$8000,00 por poste colocado, o maior valor \nque poderá gastar com a colocação desses \npostes é: \n \nA) R$ 512.000,00. \nB) R$ 520.000,00. \nC) R$ 528.000,00. \nD) R$ 552.000,00. \nE) R$ 584.000,00.",
    "alternativas": {
      "C": "R$ 528.000,00.",
      "D": "R$ 552.000,00.",
      "E": "R$ 584.000,00.",
      "A": "R$ 512.000,00."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 951,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0952",
    "numero": 2452,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "De acordo com a Lei Universal da Gravitação, \nproposta por Isaac Newton, a intensidade da \nforça gravitacional F que a Terra exerce sobre \num satélite em órbita circular é proporcional à \nmassa m do satélite e inversamente proporcio-\nnal ao quadrado do raio r da órbita, ou seja: \n \n \nNo plano cartesiano, três satélites, A, B e C, \nestão representados, cada um, por um ponto  \n(m ; r) cujas coordenadas são, respectivamente, \na massa do satélite e o raio da sua órbita em \ntorno da Terra. \n \n \n \nCom base nas posições relativas dos pontos no \ngráfico, deseja-se comparar as intensidades FA, \nFB e FC da força gravitacional que a Terra exer-\nce sobre os satélites A, B e C, respectivamente. \n \nAs intensidades FA, FB e FC expressas no gráfi-\nco satisfazem a relação: \n \nA) FC = FA < FB \nB) FA = FB < FC \nC) FA < FB < FC \nD) FA < FC < FB \nE) FC < FA < FB",
    "alternativas": {
      "A": "FC = FA < FB",
      "B": "FA = FB < FC",
      "D": "FA < FC < FB",
      "E": "FC < FA < FB"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 952,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0953",
    "numero": 2453,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Os tipos de prata normalmente vendidos são \n975, 950 e 925. Essa classificação é feita de \nacordo com a sua pureza. Por exemplo, a prata \n975 é a substância constituída de 975 partes de \nprata pura e 25 partes de cobre em 1000 partes \nda substância. Já a prata 950 é constituída de \n950 partes de prata pura e 50 de cobre em \n1000; e a prata 925 é constituída de 925 partes \nde prata pura e 75 partes de cobre em 1 000. \nUm ourives possui 10 gramas de prata 925 e \ndeseja obter 40 gramas de prata 950 para pro-\ndução de uma joia. \n \nNessas condições, quantos gramas de prata e \nde cobre, respectivamente, devem ser fundidos \ncom os 10 gramas de prata 925? \n \nA) 29,25 e 0,75 \nB) 28,75 e 1,25 \nC) 28,50 e 1,50 \nD) 27,75 e 2,25 \nE) 25,00 e 5,00",
    "alternativas": {
      "E": "25,00 e 5,00",
      "A": "29,25 e 0,75",
      "B": "28,75 e 1,25",
      "C": "28,50 e 1,50"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 953,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0954",
    "numero": 2454,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Em um aeroporto, os passageiros devem sub-\nmeter suas bagagens a uma das cinco máqui-\nnas de raio-X disponíveis ao adentrarem a sala \nde embarque.  \n \nNum dado instante, o tempo gasto por essas \nmáquinas para escanear a bagagem de cada \npassageiro e o número de pessoas presentes \nem cada fila estão apresentados em um painel, \ncomo mostrado na figura. \n \n \n \nUm passageiro, ao chegar à sala de embarque \ndesse aeroporto no instante indicado, visando \nesperar o menor tempo possível, deverá se \ndirigir à máquina: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "A": "1.",
      "B": "2.",
      "C": "3.",
      "D": "4."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 954,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0955",
    "numero": 2455,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A Comissão Interna de Prevenção de Acidentes \n(CIPA) de uma empresa, observando os altos \ncustos com os frequentes acidentes de trabalho \nocorridos, fez, a pedido da diretoria, uma pes-\nquisa do número de acidentes sofridos por fun-\ncionários.  \n \nEssa pesquisa, realizada com uma amostra de \n100 funcionários, norteará as ações da empresa \nna política de segurança no trabalho. Os resul-\ntados obtidos estão no quadro. \n \n \nA média do número de acidentes por funcionário \nna amostra que a CIPA apresentará à diretoria \nda empresa é: \n \nA) 0,15. \nB) 0,30. \nC) 0,50. \nD) 1,11. \nE) 2,22.",
    "alternativas": {
      "B": "0,30.",
      "C": "0,50.",
      "D": "1,11.",
      "E": "2,22."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 955,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0956",
    "numero": 2456,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Numa atividade de treinamento realizada no \nExército de um determinado país, três equipes – \nAlpha, Beta e Gama – foram designadas a per-\ncorrer diferentes caminhos, todos com os mes-\nmos pontos de partida e de chegada. \n \n• A equipe Alpha realizou seu percurso em \n90 minutos com uma velocidade média de \n6,0 km/h. \n \n• A equipe Beta também percorreu sua traje-\ntória em 90 minutos, mas sua velocidade \nmédia foi de 5,0 km/h. \n \n• Com uma velocidade média de 6,5 km/h, a \nequipe Gama concluiu seu caminho em 60 \nminutos. \n \nCom base nesses dados, foram comparadas as \ndistâncias percorridas pelas três equipes. \n \nA ordem das distâncias percorridas pelas equi-\npes Alpha, Beta e Gama é: \n \nA) dGama < dBeta < dAlpha \nB) dAlpha = dBeta < dGama \nC) dGama < dBeta = dAlpha \nD) dBeta < dAlpha < dGama \nE) dGama < dAlpha < dBeta",
    "alternativas": {
      "E": "dGama < dAlpha < dBeta",
      "A": "dGama < dBeta < dAlpha",
      "C": "dGama < dBeta = dAlpha",
      "D": "dBeta < dAlpha < dGama"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 956,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0957",
    "numero": 2457,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O colesterol total de uma pessoa é obtido pela \nsoma da taxa do seu “colesterol bom” com a \ntaxa do seu “colesterol ruim”. Os exames perió-\ndicos, realizados em um paciente adulto, apre-\nsentaram taxa normal de “colesterol bom”, po-\nrém, taxa do “colesterol ruim” (também chama-\ndo LDL) de 280 mg/dL. O quadro apresenta \numa classificação de acordo com as taxas de \nLDL em adultos. \nO paciente, seguindo as recomendações médi-\ncas sobre estilo de vida e alimentação, realizou \no exame logo após o primeiro mês, e a taxa de \nLDL reduziu 25%. No mês seguinte, realizou \nnovo exame e constatou uma redução de mais \n20% na taxa de LDL. \n \nDe acordo com o resultado do segundo exame, \na classificação da taxa de LDL do paciente é: \n \nA) ótima. \nB) próxima de ótima. \nC) limite \nD) alta. \nE) muito alta.",
    "alternativas": {
      "D": "alta.",
      "E": "muito alta.",
      "A": "ótima.",
      "B": "próxima de ótima."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 957,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0959",
    "numero": 2459,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A Ecofont possui design baseado na velha fonte \nVera Sans. Porém, ela tem um diferencial: pe-\nquenos buraquinhos circulares congruentes, e \nem todo o seu corpo, presentes em cada símbo-\nlo. Esses furos proporcionam um gasto de tinta \nmenor na hora da impressão. \n \n \n \n(Disponível em: www.goo.gl.  \nAcesso em: 2 dez. 2017 – adaptado) \n \nSuponha que a palavra ECO esteja escrita nes-\nsa fonte, com tamanho 192, e que seja compos-\nta por letras formadas por quadrados de lados x \ncom furos circulares de raio r = x/3  Para que a \nárea a ser pintada seja reduzida a 1/16  da área \ninicial, pretende-se reduzir o tamanho da fonte. \nSabe-se que, ao alterar o tamanho da fonte, o \ntamanho da letra é alterado na mesma propor-\nção. \n \nNessas condições, o tamanho adequado da \nfonte será: \n \nA) 64. \nB) 48. \nC) 24. \nD) 21. \nE) 12.",
    "alternativas": {
      "B": "48.",
      "C": "24.",
      "D": "21.",
      "A": "64."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 959,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0960",
    "numero": 2460,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Para ganhar um prêmio, uma pessoa deverá \nretirar, sucessivamente e sem reposição, duas \nbolas pretas de uma mesma urna. \n \nInicialmente, as quantidades e cores das bolas \nsão como descritas a seguir: \n \n• Urna A – Possui três bolas brancas, duas \nbolas pretas e uma bola verde; \n \n• Urna B – Possui seis bolas brancas, três \nbolas pretas e uma bola verde; \n \n• Urna C – Possui duas bolas pretas e duas \nbolas verdes; \n \n• Urna D – Possui três bolas brancas e três \nbolas pretas. \nA pessoa deve escolher uma entre as cinco \nopções apresentadas: \n \n• Opção 1 – Retirar, aleatoriamente, duas \nbolas da urna A; \n \n• Opção 2 – Retirar, aleatoriamente, duas \nbolas da urna B; \n \n• Opção 3 – Passar, aleatoriamente, uma \nbola da urna C para a urna A; após isso, re-\ntirar, aleatoriamente, duas bolas da urna A; \n \n• Opção 4 – Passar, aleatoriamente, uma \nbola da urna D para a urna C; após isso, \nretirar, aleatoriamente, duas bolas da urna \nC; \n \n• Opção 5 – Passar, aleatoriamente, uma \nbola da urna C para a urna D; após isso, \nretirar, aleatoriamente, duas bolas da urna \nD. \n \nCom o objetivo de obter a maior probabilidade \npossível de ganhar o prêmio, a pessoa deve \nescolher a opção: \n \nA) 1. \nB) 2. \nC) 3. \nD) 4. \nE) 5.",
    "alternativas": {
      "B": "2.",
      "C": "3.",
      "D": "4.",
      "E": "5."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 960,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0961",
    "numero": 2461,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Para criar um logotipo, um profissional da área \nde design gráfico deseja construí-lo utilizando o \nconjunto de pontos do plano na forma de um \ntriângulo,  exatamente como mostra a imagem. \n \n \n \nPara construir tal imagem utilizando uma ferra-\nmenta gráfica, será necessário escrever algebri-\ncamente o conjunto que representa os pontos \ndesse gráfico. Esse conjunto é dado pelos pares \nordenados (x;y) € IN x IN, tais que: \nA) 0 ≤ x ≤ y ≤ 10 \nB) 0 ≤ y ≤ x ≤ 10 \nC) 0 ≤ x ≤ 10, 0 ≤ y ≤ 10 \nD) 0 ≤ x + y ≤ 10 \nE) 0 ≤ x + y ≤ 20",
    "alternativas": {
      "E": "0 ≤ x + y ≤ 20",
      "A": "0 ≤ x ≤ y ≤ 10",
      "B": "0 ≤ y ≤ x ≤ 10",
      "D": "0 ≤ x + y ≤ 10"
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 961,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0962",
    "numero": 2462,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A figura mostra uma praça circular que contém \num chafariz em seu centro e, em seu entorno, \num passeio. Os círculos que definem a praça e \no chafariz são concêntricos. \n \n \n \nO passeio terá seu piso revestido com ladrilhos. \nSem condições de calcular os raios, pois o cha-\nfariz está cheio, um engenheiro fez a seguinte \nmedição: esticou uma trena tangente ao chafa-\nriz, medindo a distância entre dois pontos A e B, \nconforme a figura. Com isso, obteve a medida \ndo segmento de reta AB: 16 m. \n \n \n \nDispondo apenas dessa medida, o engenheiro \ncalculou corretamente a medida da área do \npasseio, em metro quadrado. A medida encon-\ntrada pelo engenheiro foi: \n \nA) 4 𝜋. \nB) 8 𝜋. \nC) 48 𝜋. \nD) 64 𝜋. \nE) 192 𝜋.",
    "alternativas": {
      "E": "192 𝜋.",
      "A": "4 𝜋.",
      "B": "8 𝜋.",
      "D": "64 𝜋."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 962,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0963",
    "numero": 2463,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A inclinação de uma rampa é calculada da seguinte maneira: para cada metro medido na horizontal, \nmede-se x centímetros na vertical. Diz-se, nesse caso, que a rampa tem inclinação de x%, como no \nexemplo da figura: \n \n \n \nA figura apresenta um projeto de uma rampa de acesso a uma garagem residencial cuja base, situada 2 \nmetros abaixo do nível da rua, tem 8 metros de comprimento. \n \n \n \nDepois de projetada a rampa, o responsável pela obra foi informado de que as normas técnicas do muni-\ncípio onde ela está localizada exigem que a inclinação máxima de uma rampa de acesso a uma garagem \nresidencial seja de 20%. Se a rampa projetada tiver inclinação superior a 20%, o nível da garagem deve-\nrá ser alterado para diminuir o percentual de inclinação, mantendo o comprimento da base da rampa. \n \nPara atender às normas técnicas do município, o nível da garagem deverá ser: \n \nA) elevado em 40 cm. \nB) elevado em 50 cm. \nC) mantido no mesmo nível. \nD) rebaixado em 40 cm. \nE) rebaixado em 50 cm.",
    "alternativas": {
      "C": "mantido no mesmo nível.",
      "E": "rebaixado em 50 cm.",
      "A": "elevado em 40 cm.",
      "B": "elevado em 50 cm."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 963,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0964",
    "numero": 2464,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O remo de assento deslizante é um esporte que \nfaz uso de um barco e dois remos do mesmo \ntamanho. A figura mostra uma das posições de \numa técnica chamada afastamento. \n \n \n*Imagem anterior disponível em www.remobrasil.com.  \nAcesso em: 6 dez. 2017 - adaptado. \n \nNessa posição, os dois remos se encontram no \nponto A e suas outras extremidades estão indi-\ncadas pelos pontos B e C. Esses três pontos \nformam um triângulo ABC cujo ângulo BÂC tem \nmedida de 170°. \n \nO tipo de triângulo com vértices nos pontos A, B \ne C, no momento em que o remador está nessa \nposição, é: \n \nA) retângulo escaleno. \nB) acutângulo escaleno. \nC) acutângulo isósceles. \nD) obtusângulo escaleno. \nE) obtusângulo isósceles.",
    "alternativas": {
      "B": "acutângulo escaleno.",
      "C": "acutângulo isósceles.",
      "D": "obtusângulo escaleno.",
      "E": "obtusângulo isósceles."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 964,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0965",
    "numero": 2465,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um designer de jogos planeja um jogo que faz \nuso de um tabuleiro de dimensão n x n, com n ≥ \n2, no qual cada jogador, na sua vez, coloca uma \npeça sobre uma das casas vazias do tabuleiro. \nQuando uma peça é posicionada, a região for-\nmada pelas casas que estão na mesma linha ou \ncoluna dessa peça é chamada de zona de com-\nbate dessa peça. Na figura está ilustrada a zona \nde combate de uma peça colocada em uma das \ncasas de um tabuleiro de dimensão 8 x 8. \n \n \n \nO tabuleiro deve ser dimensionado de forma \nque a probabilidade de se posicionar a segunda \npeça aleatoriamente, seguindo a regra do jogo, \ne esta ficar sobre a zona de combate da primei-\nra, seja inferior a 1/5. \n \nA dimensão mínima que o designer deve adotar \npara esse tabuleiro é: \n \nA) 4 x 4. \nB) 6 x 6. \nC) 9 x 9. \nD) 10 x 10. \nE) 11 x 11.",
    "alternativas": {
      "D": "10 x 10.",
      "E": "11 x 11.",
      "B": "6 x 6.",
      "C": "9 x 9."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 965,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0966",
    "numero": 2466,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um rapaz estuda em uma escola que fica longe \nde sua casa, e por isso precisa utilizar o trans-\nporte público. Como é muito observador, todos \nos dias ele anota a hora exata (sem considerar \nos segundos) em que o ônibus passa pelo ponto \nde espera.  \n \nTambém notou que nunca consegue chegar ao \nponto de ônibus antes de 6h 15min da manhã. \nAnalisando os dados coletados durante o mês \nde fevereiro, o qual teve 21 dias letivos, ele \nconcluiu que 6h 21min foi o que mais se repetiu, \ne que a mediana do conjunto de dados é 6h \n22min. \nA probabilidade de que, em algum dos dias \nletivos de fevereiro, esse rapaz tenha apanhado \no ônibus antes de 6h 21min da manhã é, no \nmáximo, \n \nA) 4/21 \nB) 5/21 \nC) 6/21 \nD) 7/21 \nE) 8/21",
    "alternativas": {
      "E": "8/21",
      "A": "4/21",
      "C": "6/21",
      "D": "7/21"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 966,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0967",
    "numero": 2467,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um mapa é a representação reduzida e simplifi-\ncada de uma localidade. Essa redução, que é \nfeita com o uso de uma escala, mantém a pro-\nporção do espaço representado em relação ao \nespaço real.  \n \nCerto mapa tem escala 1 : 58.000.000. \n \n \n \nConsidere que, nesse mapa, o segmento de \nreta que liga o navio à marca do tesouro meça \n7,6 cm. \n \nA medida real, em quilômetro, desse segmento \nde reta é: \n \nA) 4.408. \nB) 7.632. \nC) 44.080. \nD) 76.316. \nE) 44.0800.",
    "alternativas": {
      "D": "76.316.",
      "E": "44.0800.",
      "A": "4.408.",
      "B": "7.632."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 967,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0968",
    "numero": 2468,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um produtor de milho utiliza uma área de      \n160 hectares para as suas atividades agrícolas. \nEssa área é dividida em duas partes: uma de  \n40 hectares, com maior produtividade, e outra, \nde 120 hectares, com menor produtividade. A \nprodutividade é dada pela razão entre a produ-\nção, em tonelada, e a área cultivada. Sabe-se \nque a área de 40 hectares tem produtividade \nigual a 2,5 vezes à da outra. Esse fazendeiro \npretende aumentar sua produção total em 15%, \naumentando o tamanho da sua propriedade. \nPara tanto, pretende comprar uma parte de uma \nfazenda vizinha, que possui a mesma produtivi-\ndade da parte de 120 hectares de suas terras. \n \nQual é a área mínima, em hectare, em que o \nprodutor precisará comprar?  \n \nA) 36 \nB) 33 \nC) 27 \nD) 24 \nE) 21",
    "alternativas": {
      "C": "27",
      "E": "21",
      "A": "36",
      "B": "33"
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 968,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0969",
    "numero": 2469,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "De acordo com um relatório recente da Agência \nInternacional de Energia (AIE), o mercado de \nveículos elétricos atingiu um novo marco em \n2016, quando foram vendidos mais de 750 mil \nautomóveis da categoria. Com isso, o total de \ncarros elétricos vendidos no mundo alcançou a \nmarca de 2 milhões de unidades desde que os \nprimeiros modelos começaram a ser comerciali-\nzados em 2011.  \n \nNo Brasil, a expansão das vendas também se \nverifica. A marca A, por exemplo, expandiu suas \nvendas no ano de 2016, superando em 360 \nunidades as vendas de 2015, conforme repre-\nsentado no gráfico. \n \n \n \n(Disponível em: www.tecmundo.com.br.  \nAcesso em: 5 dez. 2017) \n \nA média anual do número de carros vendidos \npela marca A, nos anos representados no gráfi-\nco, foi de: \n \nA) 192. \nB) 240. \nC) 252. \nD) 320. \nE) 420.",
    "alternativas": {
      "B": "240.",
      "C": "252.",
      "D": "320.",
      "A": "192."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 969,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0970",
    "numero": 2470,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Para apagar os focos A e B de um incêndio, que \nestavam a uma distância de 30m um do outro, \nos bombeiros de um quartel decidiram se posi-\ncionar de modo que a distância de um bombeiro \nao foco A, de temperatura mais elevada, fosse \nsempre o dobro da distância desse bombeiro ao \nfoco B, de temperatura menos elevada. \n \nNestas condições, a maior distância, em metro, \nque dois bombeiros poderiam ter entre eles é: \n \nA) 30. \nB) 40. \nC) 45. \nD) 60. \nE) 68.",
    "alternativas": {
      "C": "45.",
      "D": "60.",
      "E": "68.",
      "B": "40."
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 970,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0971",
    "numero": 2471,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Torneios de tênis, em geral, são disputados em \nsistema de eliminatória simples. Nesse sistema, \nsão disputadas partidas entre dois competido-\nres, com a eliminação do perdedor e promoção \ndo vencedor para a fase seguinte. Dessa forma, \nse na 1ª fase o torneio conta com 2n competido-\nres, então na 2ª fase restarão n competidores, e \nassim sucessivamente até a partida final. \n \nEm um torneio de tênis, disputado nesse siste-\nma, participam 128 tenistas. \n \nPara se definir o campeão desse torneio, o nú-\nmero de partidas necessárias é dado por: \n \nA) 2 X 128 \nB) 64 + 32 + 16 + 8 + 4 + 2 \nC) 128 + 64 + 32 + 16 + 8 + 4 + 2 + 1 \nD) 128 + 64 + 32 + 16 + 8 + 4 + 2 \nE) 64 + 32 + 16 + 8+ 4 + 2+ 1",
    "alternativas": {
      "E": "64 + 32 + 16 + 8+ 4 + 2+ 1",
      "A": "2 X 128",
      "C": "128 + 64 + 32 + 16 + 8 + 4 + 2 + 1",
      "D": "128 + 64 + 32 + 16 + 8 + 4 + 2"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 971,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0972",
    "numero": 2472,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O artigo 33 da lei brasileira sobre drogas prevê \na pena de reclusão de 5 a 15 anos para qual-\nquer pessoa que seja condenada por tráfico \nilícito ou produção não autorizada de drogas. \nEntretanto, caso o condenado seja réu primário, \ncom bons antecedentes criminais, essa pena \npode sofrer uma redução de um sexto a dois \nterços. \n \nSuponha que um réu primário, com bons ante-\ncedentes criminais, foi condenado pelo artigo 33 \nda lei brasileira sobre drogas. \n \nApós o benefício da redução de pena, sua pena \npoderá variar de: \n \nA) 1 ano e 8 meses a 12 anos e 6 meses. \nB) 1 ano e 8 meses a 5 anos. \nC) 3 anos e 4 meses a 10 anos. \nD) 4 anos e 2 meses a 5 anos. \nE) 4 anos e 2 meses a 12 anos e 6 meses.",
    "alternativas": {
      "E": "4 anos e 2 meses a 12 anos e 6 meses.",
      "A": "1 ano e 8 meses a 12 anos e 6 meses.",
      "B": "1 ano e 8 meses a 5 anos.",
      "D": "4 anos e 2 meses a 5 anos."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 972,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0974",
    "numero": 2474,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Um edifício tem a numeração dos andares inici-\nando no térreo (T), e continuando com primeiro, \nsegundo, terceiro, ..., até o último andar. Uma \ncriança entrou no elevador e, tocando no painel, \nseguiu uma sequência de andares, parando, \nabrindo e fechando a porta em diversos anda-\nres. A partir de onde entrou a criança, o eleva-\ndor subiu sete andares, em seguida desceu dez, \ndesceu mais treze, subiu nove, desceu quatro e \nparou no quinto andar, finalizando a sequência. \nConsidere que, no trajeto seguido pela criança, \no elevador parou uma vez no último andar do \nedifício. \n \nDe acordo com as informações dadas, o último \nandar do edifício é o: \n \nA) 16º \nB) 22º \nC) 23º \nD) 25º \nE) 32º",
    "alternativas": {
      "D": "25º",
      "A": "16º",
      "B": "22º",
      "C": "23º"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 974,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0975",
    "numero": 2475,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O Salão do Automóvel de São Paulo é um even-\nto no qual vários fabricantes expõem seus mo-\ndelos mais recentes de veículos, mostrando, \nprincipalmente, suas inovações em design e \ntecnologia. \n \n(Disponível em: http://g1.globo.com.  \nAcesso em: 4 fev. 2015 - adaptado) \n \nUma montadora pretende participar desse even-\nto com dois estandes, um na entrada e outro na \nregião central do salão, expondo, em cada um \ndeles, um carro compacto e uma caminhonete.  \n \nPara compor os estandes, foram disponibiliza-\ndos pela montadora quatro carros compactos, \nde modelos distintos, e seis caminhonetes de \ndiferentes cores para serem escolhidos aqueles \nque serão expostos. A posição dos carros den-\ntro de cada estande é irrelevante. \n \nUma expressão que fornece a quantidade de \nmaneiras diferentes que os estandes podem ser \ncompostos é: \n \nA) 𝐴10\n4  \n \nB) 𝐶10\n4  \n \nC) 𝐶4\n2 x 𝐶6\n2 x 2 x 2 \n \nD) 𝐴4\n2 x 𝐴6\n2 x 2 x 2 \n \nE) 𝐶4\n2 x 𝐶6\n2",
    "alternativas": {
      "C": "𝐶4 2 x 𝐶6 2 x 2 x 2",
      "D": "𝐴4 2 x 𝐴6 2 x 2 x 2",
      "E": "𝐶4 2 x 𝐶6 2",
      "B": "𝐶10 4"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 975,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0976",
    "numero": 2476,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Os alunos da disciplina de estatística, em um \ncurso universitário, realizam quatro avaliações \npor semestre com os pesos de 20%, 10%, 30% \ne 40%, respectivamente. No final do semestre, \nprecisam obter uma média nas quatro avalia-\nções de, no mínimo, 60 pontos para serem \naprovados. Um estudante dessa disciplina obte-\nve os seguintes pontos nas três primeiras avali-\nações: 46, 60 e 50, respectivamente. \n \nO mínimo de pontos que esse estudante precisa \nobter na quarta avaliação para ser aprovado é: \n \nA) 29,8. \nB) 71,0. \nC) 74,5. \nD) 75,5. \nE) 84,0.",
    "alternativas": {
      "D": "75,5.",
      "E": "84,0.",
      "A": "29,8.",
      "C": "74,5."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 976,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0977",
    "numero": 2477,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "O gerente do setor de recursos humanos de \numa empresa está organizando uma avaliação \nem que uma das etapas é um jogo de perguntas \ne respostas. Para essa etapa, ele classificou as \nperguntas, pelo nível de dificuldade, em fácil, \nmédio e difícil, e escreveu cada pergunta em \ncartões para colocação em uma urna. \n \nContudo, após depositar vinte perguntas de \ndiferentes níveis na urna, ele observou que 25% \ndelas eram de nível fácil. Querendo que as per-\nguntas de nível fácil sejam a maioria, o gerente \ndecidiu acrescentar mais perguntas de nível \nfácil à urna, de modo que a probabilidade de o \nprimeiro participante retirar, aleatoriamente, \numa pergunta de nível fácil seja de 75%. \n \nCom essas informações, a quantidade de per-\nguntas de nível fácil que o gerente deve acres-\ncentar à urna é igual a: \n \nA) 10. \nB) 15. \nC) 35. \nD) 40. \nE) 45.",
    "alternativas": {
      "D": "40.",
      "E": "45.",
      "A": "10.",
      "B": "15."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 977,
    "gabaritoOriginal": "D",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0978",
    "numero": 2478,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A raiva é uma doença viral e infecciosa, transmi-\ntida por mamíferos. A campanha nacional de \nvacinação antirrábica tem o objetivo de controlar \na circulação do vírus da raiva canina e felina, \nprevenindo a raiva humana. O gráfico mostra a \ncobertura (porcentagem de vacinados) da cam-\npanha, em cães, nos anos de 2013, 2015 e \n2017, no município de Belo Horizonte, em Minas \nGerais. Os valores das coberturas dos anos de \n2014 e 2016 não estão informados no gráfico e \ndeseja-se estimá-los. \nPara tal, levou-se em consideração que a varia-\nção na cobertura de vacinação da campanha \nantirrábica, nos períodos de 2013 a 2015 e de \n2015 a 2017, deu-se de forma linear. \n \n \n \n(Disponível em: http://pmi.datasus.gov.br. \nAcesso em: 5 fev. 2017 - adaptado) \n \nQual teria sido a cobertura dessa campanha no \nano de 2014? \n \nA) 62,3% \nB) 63,0% \nC) 63,5% \nD) 64,0% \nE) 65,5%",
    "alternativas": {
      "A": "62,3%",
      "B": "63,0%",
      "C": "63,5%",
      "E": "65,5%"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 978,
    "gabaritoOriginal": "B",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0979",
    "numero": 2479,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Uma empresa de comunicação tem a tarefa de \nelaborar um material publicitário de um estaleiro \npara divulgar um novo navio, equipado com um \nguindaste de 15m de altura e uma esteira de   \n90 m de comprimento. No desenho desse navio, \na representação do guindaste deve ter sua altu-\nra entre 0,5 cm e 1 cm, enquanto a esteira deve \napresentar comprimento superior a 4 cm. Todo \no desenho deverá ser feito em uma escala 1 : X. \n \nOs valores possíveis para X são, apenas, \n \nA) X > 1 500. \nB) X < 3 000. \nC) 1.500 < X < 2.250. \nD) 1.500 < X < 3.000. \nE) 2.250 < X < 3.000.",
    "alternativas": {
      "A": "X > 1 500.",
      "B": "X < 3 000.",
      "C": "1.500 < X < 2.250.",
      "D": "1.500 < X < 3.000."
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 979,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0980",
    "numero": 2480,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Na teoria das eleições, o Método de Borda su-\ngere que, em vez de escolher um candidato, \ncada juiz deve criar um ranking de sua prefe-\nrência para os concorrentes (isto é, criar uma \nlista com a ordem de classificação dos concor-\nrentes). A este ranking é associada uma pontu-\nação: um ponto para o último colocado no ran-\nking, dois pontos para o penúltimo, três para o \nantepenúltimo, e assim sucessivamente. Ao \nfinal, soma-se a pontuação atribuída a cada \nconcorrente por cada um dos juízes. \n \nEm uma escola houve um concurso de poesia \nno qual cinco alunos concorreram a um prêmio, \nsendo julgados por 25 juízes. Para a escolha da \npoesia vencedora foi utilizado o Método de Bor-\nda. Nos quadros, estão apresentados os ran-\nkings dos juízes e a frequência de cada ranking. \n \n \n \n \n \nA poesia vencedora foi a de: \n \nA) Edu. \nB) Dani. \nC) Caio. \nD) Bia. \nE) Ana.",
    "alternativas": {
      "B": "Dani.",
      "C": "Caio.",
      "D": "Bia.",
      "E": "Ana."
    },
    "correta": "D",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 980,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0981",
    "numero": 2481,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "A rosa dos ventos é uma figura que representa \noito sentidos, que dividem o círculo em partes \niguais. \n \n \n \nUma câmera de vigilância está fixada no teto de \num shopping e sua lente pode ser direcionada \nremotamente, através de um controlador, para \nqualquer sentido. A lente da câmera está apon-\ntada inicialmente no sentido Oeste e o seu con-\ntrolador efetua três mudanças consecutivas, a \nsaber: \n \n• 1ª mudança: 135° no sentido anti-horário; \n \n• 2ª mudança: 60° no sentido horário; \n \n• 3ª mudança: 45° no sentido anti-horário. \nApós a 3ª mudança, ele é orientado a reposicio-\nnar a câmera, com a menor amplitude possível, \nno sentido Noroeste (NO) devido a um movi-\nmento suspeito de um cliente. \n \nQual mudança de sentido o controlador deve \nefetuar para reposicionar a câmera? \n \nA) 75° no sentido horário. \nB) 105° no sentido anti-horário. \nC) 120° no sentido anti-horário. \nD) 135° no sentido anti-horário. \nE) 165° no sentido horário.",
    "alternativas": {
      "C": "120° no sentido anti-horário.",
      "D": "135° no sentido anti-horário.",
      "E": "165° no sentido horário.",
      "A": "75° no sentido horário."
    },
    "correta": "A",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 981,
    "gabaritoOriginal": "E",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0982",
    "numero": 2482,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Em 2014 foi inaugurada a maior roda-gigante do \nmundo, a High Roller, situada em Las Vegas. A \nfigura representa um esboço dessa roda-\ngigante, no qual o ponto A representa uma de \nsuas cadeiras: \n \n \n(Disponível em: http://en.wikipedia.org. \nAcesso em: 22 abr. 2014 - adaptado) \n \nA partir da posição indicada, em que o segmen-\nto OA se encontra paralelo ao plano do solo, \nrotaciona-se a High Roller no sentido anti-\nhorário, em torno do ponto O. Sejam t o ângulo \ndeterminado pelo segmento OA em relação à \nsua posição inicial, e f a função que descreve a \naltura do ponto A, em relação ao solo, em fun-\nção de t. Após duas voltas completas, f tem o \nseguinte gráfico: \n \n \nA expressão da função altura é dada por: \n \nA) f(t) = 80sen(t) + 88 \nB) f(t) = 80cos(t) + 8 8 \nC) f(t) = 88cos(t) + 168 \nD) f(t) = 168sen(t) + 88cos(t) \nE) f(t) = 88sen(t) + 168cos(t)",
    "alternativas": {
      "B": "f(t) = 80cos(t) + 8 8",
      "D": "f(t) = 168sen(t) + 88cos(t)",
      "E": "f(t) = 88sen(t) + 168cos(t)",
      "A": "f(t) = 80sen(t) + 88"
    },
    "correta": "B",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 982,
    "gabaritoOriginal": "A",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  },
  {
    "id": "mat-enem-0983",
    "numero": 2483,
    "area": "Matemática e suas Tecnologias",
    "areaCurta": "Matemática",
    "habilidade": "",
    "referencia": "ENEM 2018.1",
    "enunciado": "Com o avanço em ciência da computação, es-\ntamos próximos do momento em que o número \nde transistores no processador de um computa-\ndor pessoal será da mesma ordem de grandeza \nque o número de neurônios em um cérebro \nhumano, que é da ordem de 100 bilhões. \n \nUma das grandezas determinantes para o de-\nsempenho de um processador é a densidade de \ntransistores, que é o número de transistores por \ncentímetro quadrado. Em 1986, uma empresa \nfabricava um processador contendo 100 000 \ntransistores distribuídos em 0,25 cm² de área. \nDesde então, o número de transistores por cen-\ntímetro quadrado que se pode colocar em um \nprocessador dobra a cada dois anos (Lei de \nMoore). \n \n(Disponível em: www.pocket-lint.com.  \nAcesso em: 1 dez. 2017 - adaptado) \n \nConsidere 0,30 como aproximação para log102. \n \nEm que ano a empresa atingiu ou atingirá a \ndensidade de 100 bilhões de transistores? \n \nA) 1999 \nB) 2002 \nC) 2022 \nD) 2026 \nE) 2146",
    "alternativas": {
      "A": "1999",
      "B": "2002",
      "C": "2022",
      "E": "2146"
    },
    "correta": "C",
    "justificativa": "",
    "origem": "2018.1",
    "numeroOriginal": 983,
    "gabaritoOriginal": "C",
    "adaptacao": "5→4; uma alternativa incorreta removida e a ordem redistribuída de forma determinística.",
    "status": "ativo"
  }
];